import "./Handbag.css"
import Product1 from "../Components/Product1"

import Mobile1 from "../images/mobile1.webp"
import Mobile2 from "../images/mobile2.webp"
import Mobile3 from "../images/mobile3.jpg"
import Mobile4 from "../images/mobile4.jpg"
import Mobile5 from "../images/mobile5.jpg"
import Mobile6 from "../images/mobile6.jpg"
import Mobile7 from "../images/mobile7.jpg"
import Mobile8 from "../images/mobile8.jpg"
import Mobile9 from "../images/mobile9.jpg"


export default function Handbag() {

  return (
    <div className="stdivinhome">
       <div className="add"><img src={Mobile9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <strong><Product1  id="mobiles1"  prdName="SAMSUNG TAB A" img={Mobile1} price=" Price : ₹ 55,580" review="5.5" buttonCart="Add to cart"  ></Product1></strong>
            <strong>  <Product1 id="mobiles2" prdName="REDMI 9" img={Mobile2} price="Price : ₹ 9580" review="5.5" buttonCart="Add to cart"></Product1>          </strong>

          </div>

          <div className="home__prd1">

          
          <Product1 id="mobiles3" prdName="SAMSUNG M32" img={Mobile3} price="Price : ₹ 15,580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="mobiles4" prdName="OPPO A52" img={Mobile4} price=" Price : ₹ 15,580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="mobiles5" prdName="REAL ME NARZO" img={Mobile5} price=" Price : ₹ 15,580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="mobiles6" prdName="MI 10S" img={Mobile6} price=" Price : ₹ 25,580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1  id="mobiles7"prdName="MI 11X" img={Mobile7} price=" Price : ₹ 23,580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="mobiles8"prdName="MI 10" img={Mobile8} price=" Price : ₹ 15,580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}